'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of import patient list web
 */ const ImportPatientListWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.957",
                y: "31.6211",
                width: "63.9459",
                height: "37.2432",
                rx: "3.51351",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.957 62.1196V65.352C19.957 67.2925 21.5301 68.8655 23.4705 68.8655H80.3895C82.3299 68.8655 83.903 67.2925 83.903 65.352V62.1196H19.957Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1641",
                y: "68.8652",
                width: "19.6757",
                height: "6.04324",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2773",
                y: "74.7676",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "35",
                y: "54",
                width: "40",
                height: "1.935",
                rx: "0.967498",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "35",
                y: "57.0664",
                width: "40",
                height: "1.935",
                rx: "0.967498",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M28.1286 57.7867C28.0446 58.0327 28 58.2928 28 58.5556V59H32.3781V58.55C32.3781 58.2928 32.3363 58.0355 32.2495 57.7922V57.7867C32.0679 57.2806 31.6848 56.8892 31.2122 56.6797C30.9215 56.8836 30.5663 57.001 30.1892 57.001C29.8121 57.001 29.4566 56.8836 29.1659 56.6825C28.6908 56.8895 28.3106 57.2834 28.1286 57.7867Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M30.1906 56.3976C30.857 56.3976 31.4008 55.8567 31.4008 55.1875C31.4008 54.5183 30.857 53.9805 30.1906 53.9805C29.5242 53.9805 28.9805 54.5214 28.9805 55.1875C28.9805 55.8536 29.5245 56.3976 30.1906 56.3976Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "35",
                y: "45.0195",
                width: "40",
                height: "1.935",
                rx: "0.967498",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "35",
                y: "48.0859",
                width: "40",
                height: "1.935",
                rx: "0.967498",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M28.1286 48.8062C28.0446 49.0523 28 49.3123 28 49.5751V50.0195H32.3781V49.5695C32.3781 49.3123 32.3363 49.0551 32.2495 48.8118V48.8062C32.0679 48.3001 31.6848 47.9087 31.2122 47.6992C30.9215 47.9031 30.5663 48.0206 30.1892 48.0206C29.8121 48.0206 29.4566 47.9031 29.1659 47.702C28.6908 47.909 28.3106 48.3029 28.1286 48.8062Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M30.1906 47.4172C30.857 47.4172 31.4008 46.8762 31.4008 46.207C31.4008 45.5378 30.857 45 30.1906 45C29.5242 45 28.9805 45.5409 28.9805 46.207C28.9805 46.8731 29.5245 47.4172 30.1906 47.4172Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "35",
                y: "36.0195",
                width: "40",
                height: "1.935",
                rx: "0.967498",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                opacity: "0.7",
                x: "35",
                y: "39.0859",
                width: "40",
                height: "1.935",
                rx: "0.967498",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M28.1286 39.8062C28.0446 40.0523 28 40.3123 28 40.5751V41.0195H32.3781V40.5695C32.3781 40.3123 32.3363 40.0551 32.2495 39.8118V39.8062C32.0679 39.3001 31.6848 38.9087 31.2122 38.6992C30.9215 38.9031 30.5663 39.0206 30.1892 39.0206C29.8121 39.0206 29.4566 38.9031 29.1659 38.702C28.6908 38.909 28.3106 39.3029 28.1286 39.8062Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M30.1906 38.4172C30.857 38.4172 31.4008 37.8762 31.4008 37.207C31.4008 36.5378 30.857 36 30.1906 36C29.5242 36 28.9805 36.5409 28.9805 37.207C28.9805 37.8731 29.5245 38.4172 30.1906 38.4172Z",
                fill: theme.ds5.asset[assetColor]["600"]
            })
        ]
    });
};

exports.ImportPatientListWeb = ImportPatientListWeb;
//# sourceMappingURL=ImportPatientListWeb.cjs.map
